module.exports = __webpack_public_path__ + "static/media/3.066612a6.jpg";